import { motion } from "framer-motion";
import { BookOpen, FileText, Download } from "lucide-react";

export default function Malla({ malla, mallaCurricular }) {
  return (
    <section className="pt-6">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div className="relative overflow-hidden rounded-3xl">
          <div className="relative z-10 p-8 lg:p-12">
            {/* Header */}

            <div className="flex items-center gap-4 mb-6">
              <div>
                <h2 className="font-bold">Malla curricular</h2>
              </div>
            </div>

            {/* Contenido */}

            <div
              className="
                rounded-2xl
                bg-slate-50
                border
                border-slate-200
                p-8
                prose
                prose-lg
                max-w-none

                prose-headings:text-slate-900
                prose-p:text-slate-700
                prose-strong:text-[#004270]

                [&_p]:leading-8

                [&_ul]:list-none
                [&_ul]:pl-0
                [&_ul]:space-y-0
                [&_li]:relative
                [&_li]:pl-8
                [&_li]:py-2
                [&_li]:border-b
                [&_li]:border-slate-200
                [&_li]:leading-7
                [&_li]:transition
          
                [&_li::before]:hidden
                [&_li:last-child]:border-b-0
              "
              dangerouslySetInnerHTML={{
                __html: malla,
              }}
            />

            {/* PDF */}

            {mallaCurricular && (
              <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6">
                  <div className="flex gap-4">
                    <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center">
                      <FileText size={24} className="text-[#004270]" />
                    </div>

                    <div>
                      <h3 className="font-semibold">
                        Descargar malla curricular
                      </h3>

                      <p className="text-sm text-slate-600 mt-1">
                        Consulta el documento completo con la planificación
                        académica del programa.
                      </p>
                    </div>
                  </div>

                  <a
                    href={mallaCurricular}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 rounded-xl bg-[#004270] px-6 py-3 text-white font-semibold hover:bg-[#00345a] transition"
                  >
                    <Download size={18} />
                    Descargar PDF
                  </a>
                </div>
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
